import React from 'react';
import { cn } from '../../lib/utils';

export interface LabelProps
  extends React.LabelHTMLAttributes<HTMLLabelElement> {
  /** Label text */
  children: React.ReactNode;
  /** Show required indicator (*) */
  required?: boolean;
}

/**
 * Label component for form fields
 *
 * @example
 * ```tsx
 * <Label htmlFor="email">Email Address</Label>
 * <Label htmlFor="name" required>Full Name</Label>
 * ```
 */
export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ children, required = false, className, ...props }, ref) => {
    return (
      <label ref={ref} className={cn('label', className)} {...props}>
        {children}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
    );
  }
);

Label.displayName = 'Label';
